import React, {Component} from 'react';
import {
  Layout,
  Page,
  Card,
} from '@shopify/polaris';

class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const primaryAction = {content: 'Go Pro', onAction: () => { this.changePage('/pro'); }};
    const secondaryActions = [{content: 'Home', onAction: () => { this.changePage('/'); }},{content: 'FAQ', onAction: () => { this.changePage('/faq'); }},{content: 'Privacy Policy', onAction: () => { this.changePage('/terms'); }}];

    return (
      <Page
        title="404 Not Found"
        primaryAction={primaryAction}
        secondaryActions={secondaryActions}
      >
        <Layout>
          <Layout.Section>
            <Card title="Error 404" sectioned>
              <p>The page you're looking for can't be found, most likely the link is broken or the page has been moved. Return home using the navigation buttons above.</p>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  // Change our page
  changePage = (url, keepParams = true) => {
    this.props.history.push(url + (keepParams ? window.location.search : ''));
  }

  valueUpdater(field) {
    return (value) => this.setState({[field]: value});
  }
}

export default NotFound;
